import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import facebookReducer from './slices/facebookSlice';
import whatsappReducer from './slices/whatsappSlice';
import telegramReducer from './slices/telegramSlice';
import instagramReducer from './slices/instagramSlice';
import campaignReducer from './slices/campaignSlice';
import scheduledPostReducer from './slices/scheduledPostSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    facebook: facebookReducer,
    whatsapp: whatsappReducer,
    telegram: telegramReducer,
    instagram: instagramReducer,
    campaign: campaignReducer,
    scheduledPosts: scheduledPostReducer,
  },
});